import {Text} from '@dropbox/dig-components/typography';
import {Box, Stack} from '@dropbox/dig-foundations';
import {pulseUserAtom} from 'atoms/auth';
import {Layout} from 'components/DSYS/Layout';
import {Link} from 'components/DSYS/Link';
import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {t} from 'i18next';
import {useAtomValue} from 'jotai';
import {renderCannyWidget} from 'lib/canny';
import {useEffect} from 'react';

export const Feedback = () => {
  useDocumentTitle('Feedback');
  const user = useAtomValue(pulseUserAtom);

  useEffect(() => {
    if (user?.canny_sso_token) {
      renderCannyWidget(user?.canny_sso_token);
    }
  }, [user?.canny_sso_token]);

  return (
    <Layout.Container>
      <Box paddingX="32">
        <Stack gap="16">
          <Text>
            This is the place to share product ideas and request features. You can also upvote
            existing posts to help us prioritize what to build next. <br /> <br />
            Need immediate help or want to report a bug? Head to{' '}
            <Link to="https://dropbox.enterprise.slack.com/archives/C05NS4VV5QV">
              {t('companyos_feedback')}
            </Link>{' '}
            to get support. <br /> <br />
            Want to talk to us directly and share your feedback? You can{' '}
            <Link to="https://app.reclaim.ai/m/companyos/feedback">schedule time</Link> with our
            team.
          </Text>
        </Stack>
      </Box>
      <Box marginTop="16" data-canny />
    </Layout.Container>
  );
};
